import { Popover, Transition } from "@headlessui/react";
import {
  CashIcon,
  DocumentDuplicateIcon,
  DocumentIcon,
  MenuIcon,
  XIcon,
} from "@heroicons/react/outline";
import React, { Fragment } from "react";
import { useLocation } from "react-router-dom";
import AstroLogo from "../assets/images/astro.png";

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  const { pathname } = useLocation();

  return (
    <Popover className="relative bg-white sticky top-0 z-10">
      <div className="max-w-12xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
          <div className="flex justify-start lg:w-0 lg:flex-1">
            <a href="/#">
              <span className="sr-only">Astro</span>
              <img className="h-8 w-auto sm:h-10" src={AstroLogo} alt="Astro" />
            </a>
          </div>
          {/* <div className="-mr-2 -my-2 md:hidden">
            <Popover.Button
              className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 
                        hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500"
            >
              <span className="sr-only">Open menu</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" />
            </Popover.Button>
          </div> */}
          <Popover.Group as="nav" className="hidden md:flex space-x-10">
            {/* <a
              href="/sms-cost-calculator"
              className={`text-base font-medium ${
                pathname === "/sms-cost-calculator"
                  ? "text-pink-700"
                  : "text-gray-500"
              } hover:text-pink-700`}
            >
              SMS Cost Calculator
            </a> */}
            {/* <a
                            href='/mobile-validation'
                            className={`text-base font-medium ${
                                pathname === '/mobile-validation' ? 'text-pink-700' : 'text-gray-500'
                            } hover:text-pink-700`}
                        >
                            Mobile Validation
                        </a>
                        <a
                            href='/bulk-mobile-validation'
                            className={`text-base font-medium ${
                                pathname === '/bulk-mobile-validation' ? 'text-pink-700' : 'text-gray-500'
                            } hover:text-pink-700`}
                        >
                            Bulk Mobile Validation
                        </a> */}
          </Popover.Group>
          <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
            {/* <a href='/#' className='whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900'>
                            Test
                        </a> */}
            <a
              href="/"
              className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent 
                            rounded-md shadow-sm text-base font-medium text-white bg-pink-600 hover:bg-pink-700 uppercase"
            >
              UNS Tools
            </a>
          </div>
        </div>
      </div>
      <Transition
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel
          focus
          className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-10"
        >
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
            <div className="pt-5 pb-6 px-5">
              <div className="flex items-center justify-between">
                <div>
                  <img className="h-8 w-auto" src={AstroLogo} alt="Workflow" />
                </div>
                <div className="-mr-2">
                  <Popover.Button
                    className="bg-white rounded-md p-2 inline-flex items-center justify-center 
                                    text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-500"
                  >
                    <span className="sr-only">Close menu</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>
              <div className="mt-6">
                <nav className="grid gap-y-8">
                  <a
                    href="/sms-cost-calculator"
                    className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                  >
                    <CashIcon
                      className="flex-shrink-0 h-6 w-6 text-pink-600"
                      aria-hidden="true"
                    />
                    <span
                      className={`ml-3 text-base font-medium ${
                        pathname === "/sms-cost-calculator"
                          ? "text-pink-700"
                          : "text-gray-900"
                      }`}
                    >
                      SMS Cost Calculator
                    </span>
                  </a>
                  <a
                    href="/mobile-validation"
                    className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                  >
                    <DocumentIcon
                      className="flex-shrink-0 h-6 w-6 text-pink-600"
                      aria-hidden="true"
                    />
                    <span
                      className={`ml-3 text-base font-medium ${
                        pathname === "/mobile-validation"
                          ? "text-pink-700"
                          : "text-gray-900"
                      }`}
                    >
                      Mobile Validation
                    </span>
                  </a>
                  <a
                    href="/bulk-mobile-validation"
                    className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                  >
                    <DocumentDuplicateIcon
                      className="flex-shrink-0 h-6 w-6 text-pink-600"
                      aria-hidden="true"
                    />
                    <span
                      className={`ml-3 text-base font-medium ${
                        pathname === "/bulk-mobile-validation"
                          ? "text-pink-700"
                          : "text-gray-900"
                      }`}
                    >
                      Bulk Mobile Validation
                    </span>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};

export default Header;
